export default {
  methods: {
    assetApplicationFeaturesHasSomeString(asset, stringToFilter) {
      return asset.applicationFeatures.some(
        feature => stringToFilter && stringToFilter.includes(feature),
      );
    },
    getFilteredTypesAndAssetsByAppFeature(stringToFilter) {
      const filteredTypes = this.typesWithAssets.filter(
        type => type.assets.some(
          asset => this.assetApplicationFeaturesHasSomeString(asset, stringToFilter),
        ),
      );
      return filteredTypes.map(type => ({
        ...type,
        assets: type.assets.filter(
          asset => this.assetApplicationFeaturesHasSomeString(asset, stringToFilter),
        ),
      }));
    },
  },
};
